
import { useEffect, useState } from "react";

import { useDispatch, useSelector } from 'react-redux';

import { useNavigate } from "react-router";

import { RootState } from '../../store';

import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Switch, IconButton, TableFooter, TablePagination, Typography, Button, Grid, Dialog, DialogActions, DialogContent, CircularProgress, Select, MenuItem, FormControl, InputLabel, Paper } from "@mui/material"

import EditIcon from "@mui/icons-material/Edit";
import UndoIcon from '@mui/icons-material/Undo';

import { openSnackbar } from "../../store/slices/SnackbarSlice";

import { Layout } from "../../components/Layout"

import { SearchTextField } from "../../components/SearchTextField";

import { TablePaginationActions } from "../../helpers/TablePaginationActions";
import { usePages } from "../../hooks/usePages";
import { useFilter } from "../../hooks/useFilter";

import { TablePaddingStyle, TableTheadStyle } from '../../styles/TableStyle';
import { DialogActionsStyle, DialogContentStyle } from "../../styles/DialogStyle";

import { ActualizarTipoJuicioMateria, AgregarTipoJuicioMateria, TiposJuicioMateria } from "../../connections/catalogos/TipoJuicioMateriaConnection";
import { ObtenerMateria } from "../../connections/catalogos/MateriaConnection";
import { ObtenerTipoJuicio } from "../../connections/catalogos/TipoJuicioConnection";

import { TipoJuicioMateriaProps } from "../../interfaces/catalogos/TipoJuicioMateriaInterface";
import { TipoJuicioProps } from "../../interfaces/catalogos/TipoJuicioInterface";
import { MateriaProps } from "../../interfaces/catalogos/MateriaInterface";

export const TipoJuicioMateriaPage = () => {

    const dispatch = useDispatch();

    const navigate = useNavigate();

    const { administrador } = useSelector( ( state: RootState ) => state.auth );

    const [tipoJuicioMateriaArray, setTipoJuicioMateriaArray] = useState<TipoJuicioMateriaProps[]>([]);

    const [openModal, setOpenModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [loadingData, setLoadingData] = useState(true);

    const [idTipoJuicioMateria, setIdTipoJuicioMateria] = useState(0);

    const [materia, setMateria] = useState(0);
    const [materiaArray, setMateriaArray] = useState<MateriaProps[]>([]);

    const [tipoJuicio, setTipoJuicio] = useState(0);
    const [tipoJuicioArray, setTipoJuicioArray] = useState<TipoJuicioProps[]>([]);

    const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage, resetPage } = usePages( 10 );

    const { filtro, setFiltro, dataFiltrada: dataFiltrada1 } = useFilter( tipoJuicioMateriaArray, ( item, filtro ) => (item.tipoJuicio?.descripcion ?? "").toLowerCase().includes( filtro.toLowerCase() ) );
    const { filtro: filtroMateria, setFiltro: setFiltroMateria, dataFiltrada } = useFilter( dataFiltrada1, ( item, filtro ) => (item.materia?.descripcion ?? "").toLowerCase().includes( filtro.toLowerCase() ) );

    const handleChangeChecked = async (checked: boolean, id: number) => {

        const tipoJuicioMateriaSelected = tipoJuicioMateriaArray.find((elem) => elem.idTipoJuicioMateria === id);

        if (tipoJuicioMateriaSelected) {

            await ActualizarTipoJuicioMateria({ ...tipoJuicioMateriaSelected, activo: checked }).then(resp => {

                if (resp.idTipoJuicio) {

                    var newArray = tipoJuicioMateriaArray.map((elem) => {

                        if (elem.idTipoJuicio === id) {
                            elem.activo = checked;
                        }

                        return elem;
                    });

                    setTipoJuicioMateriaArray(newArray);
                    dispatch( openSnackbar({ message: 'Se actualizó el registro correctamente', variant: 'success' }));   

                }

            });
        }

    }

    const handleGuardar = async () => {

        if ( idTipoJuicioMateria !== 0 ) {

            const tipoJuicioMateriaSelected = tipoJuicioMateriaArray.find((elem) => elem.idTipoJuicioMateria === idTipoJuicioMateria);

            if ( tipoJuicioMateriaSelected ) {

                setLoading(true);

                await ActualizarTipoJuicioMateria({ ...tipoJuicioMateriaSelected, idMateria: materia, idTipoJuicio: tipoJuicio, }).then(resp => {

                    if (resp.idTipoJuicio) {

                        setTimeout(() => {

                            var newArray = tipoJuicioMateriaArray.map((elem) => {

                                if (elem.idTipoJuicioMateria === idTipoJuicioMateria) {
                                    elem.idTipoJuicio = tipoJuicio;
                                    elem.tipoJuicio = resp.tipoJuicio;
                                    elem.idMateria = materia;
                                    elem.materia = resp.materia;
                                }

                                return elem;
                            });

                            setTipoJuicioMateriaArray(newArray);
                            setOpenModal(false);
                            setLoading(false);
                            
                            dispatch( openSnackbar({ message: 'Se actualizó el registro correctamente', variant: 'success' }));   

                        }, 700);

                    }

                });
            }


        }
        else {

            const TipoJuicioAdd: TipoJuicioMateriaProps = {
                idTipoJuicioMateria: 0,
                idTipoJuicio: tipoJuicio,
                idMateria: materia,
                activo: true,
            }

            setLoading(true);

            await AgregarTipoJuicioMateria( TipoJuicioAdd ).then(resp => {

                if ( resp.idTipoJuicioMateria ) {

                    setTimeout(() => {

                        setTipoJuicioMateriaArray([...tipoJuicioMateriaArray, resp]);
                        setOpenModal(false);
                        setLoading(false);
                        
                        dispatch( openSnackbar({ message: 'Se agregó el tipo de juicio - materia correctamente', variant: 'success' }));   

                    }, 700);

                }

            });

        }

    }

    useEffect(() => {

        async function obtener() {

            setLoadingData(true);
            setTipoJuicioMateriaArray([]);

            await TiposJuicioMateria().then(resp => {

                setTimeout(() => {

                    setTipoJuicioMateriaArray(resp);
                    setLoadingData(false);

                }, 700);

            });

        }

        obtener();

    }, [])

    useEffect(() => {

        async function obtener() {

            setMateriaArray([]);

            await ObtenerMateria().then(resp => {
                setMateriaArray(resp);
            });

        }

        obtener();

    }, [])

    useEffect(() => {

        async function obtener() {

            setTipoJuicioArray([]);

            await ObtenerTipoJuicio().then(resp => {     
                setTipoJuicioArray(resp);   
            });

        }

        obtener();

    }, [])

    return (

        <Layout breadcrumbs={[ { text: 'Administración' }, { text: 'Catálogos' }, { text: 'Tipo de juicio por materia' }]} backgroundPaper={false}>

            <Grid container spacing={3} >

                <Grid size={{ xs: 6 }} textAlign={'start'}>

                    {
                        administrador
                        &&
                            <Button startIcon={<UndoIcon />} color="secondary" variant="text" sx={{ mt: 1 }} onClick={() => navigate('/')}>
                                Regresar
                            </Button>
                    }

                </Grid>

                <Grid size={{ xs: 6 }} textAlign={'end'}>

                    <Button
                        variant="contained"
                        sx={{ mt: 1 }}
                        disabled={loadingData}
                        onClick={() => {

                            setIdTipoJuicioMateria(0);
                            setTipoJuicio(0);
                            setMateria(0)
                            setOpenModal(true);
                        }}
                    >
                        Agregar
                    </Button>

                </Grid>

            </Grid>

            <Grid container spacing={2} sx={{ mt: 2 }}>

                <Grid size={{ xs: 12, md: 6 }} textAlign={'start'}>

                    <SearchTextField
                        value={ filtro }
                        label="Buscar por tipo de juicio"
                        onChange={ ( value ) => {
                            setFiltro( value );
                            resetPage();
                        }}
                        onClear={ () => resetPage() }
                    />

                </Grid>

                <Grid size={{ xs: 12, md: 6 }} textAlign={'start'}>

                    <SearchTextField
                        value={ filtroMateria }
                        label="Buscar por materia"
                        onChange={ ( value ) => {
                            setFiltroMateria( value );
                            resetPage();
                        }}
                        onClear={ () => resetPage() }
                    />

                </Grid>

            </Grid>

            <TableContainer sx={{ mt: 3, borderRadius: 3 }} component={ Paper }>

                <Table sx={{ minWidth: 500 }}>

                    <TableHead sx={{ ...TableTheadStyle }}>

                        <TableRow sx={{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>

                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '15%', textAlign: 'center' }}> Id </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '35%' }}> Materia </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '35%' }}> Tipo de juicio </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '10%' }}>  </TableCell>

                        </TableRow>

                    </TableHead>

                    <TableBody>

                        {
                            (
                                rowsPerPage > 0
                                ?
                                    dataFiltrada.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                :
                                    dataFiltrada
                            )
                                .map(({ idTipoJuicioMateria, idTipoJuicio, tipoJuicio, activo, materia, idMateria }) => (

                                    <TableRow key={idTipoJuicioMateria} >

                                        <TableCell sx={{ fontWeight: 'bold', textAlign: 'center' }}>
                                            {idTipoJuicioMateria}
                                        </TableCell>

                                        <TableCell>
                                            {materia?.descripcion}
                                        </TableCell>

                                        <TableCell>
                                            {tipoJuicio?.descripcion}
                                        </TableCell>

                                        <TableCell sx={{ textAlign: 'end' }}>

                                            <Switch
                                                checked={activo}
                                                onChange={(e) => handleChangeChecked(e.target.checked, idTipoJuicioMateria)}
                                            />

                                            <IconButton
                                                color="primary"
                                                aria-label="edit"
                                                component="span"
                                                onClick={() => {
                                                    setIdTipoJuicioMateria( idTipoJuicioMateria );
                                                    setTipoJuicio( idTipoJuicio );
                                                    setMateria( idMateria );
                                                    setOpenModal( true );
                                                }}
                                            >
                                                <EditIcon />
                                            </IconButton>

                                        </TableCell>

                                    </TableRow>

                                ))
                        }

                        {
                            ( dataFiltrada.length === 0 && !loadingData )
                            ?
                                <TableRow style={{ height: 73 }}>

                                    <TableCell colSpan={7} align="center">

                                        <Typography variant="caption" color='secondary'> No se encontraron resultados </Typography>

                                    </TableCell>

                                </TableRow>
                            :
                                loadingData
                                &&
                                    <TableRow style={{ height: 73 }}>

                                        <TableCell colSpan={7} align="center">

                                            <CircularProgress size={32} />

                                        </TableCell>

                                    </TableRow>
                        }

                    </TableBody>

                    <TableFooter>

                        {
                            dataFiltrada.length !== 0
                            &&
                                <TableRow>

                                    <TableCell colSpan={2} sx={{ border: 'none' }}>
                                        <Typography variant='body2' color='black' sx={{ fontWeight: 'bold' }}>
                                            Total de registros: { dataFiltrada.length }
                                        </Typography>
                                    </TableCell>

                                    <TablePagination
                                        sx={{ border: 'none' }}
                                        rowsPerPageOptions={[5, 10, 20, 50, 100]}
                                        colSpan={8}
                                        count={dataFiltrada.length}
                                        rowsPerPage={rowsPerPage}
                                        page={page}

                                        onPageChange={handleChangePage}
                                        onRowsPerPageChange={handleChangeRowsPerPage}

                                        ActionsComponent={TablePaginationActions}

                                        labelRowsPerPage="Filas por página"
                                        labelDisplayedRows={
                                            ({ from, to, count }) => {
                                                return '' + from + '-' + to + ' de ' + count
                                            }
                                        }
                                    />

                                </TableRow>
                        }

                    </TableFooter>

                </Table>

            </TableContainer>

            <Dialog open={openModal} maxWidth='sm' fullWidth={true}>

                <DialogContent sx={ DialogContentStyle }>

                    <Grid container spacing={3} sx={{ mt: 3 }}>

                        <Grid size={{ md: 12, xs: 12 }}>
                            <FormControl fullWidth>
                                <InputLabel>Tipo de juicio</InputLabel>
                                <Select
                                    label="Tipo de juicio"
                                    value={ tipoJuicio }
                                    onChange={(e) => { setTipoJuicio(  e.target.value  ); }}
                                >
                                    <MenuItem key={0} value={0}>Selecciona una opción</MenuItem>
                                    {
                                        tipoJuicioArray.map((elem) => (
                                            <MenuItem key={elem.idTipoJuicio} value={elem.idTipoJuicio}> {elem.descripcion} </MenuItem>
                                        ))
                                    }
                                </Select>
                            </FormControl>
                        </Grid>
                
                        <Grid size={{ md: 12, xs: 12 }}>
                            <FormControl fullWidth>
                                <InputLabel>Materia</InputLabel>
                                <Select
                                    label="Materia"
                                    value={materia}
                                    onChange={(e) => { setMateria(  e.target.value  ); }}
                                >
                                    <MenuItem key={0} value={0}>Selecciona una opción</MenuItem>
                                    {
                                        materiaArray.map((elem) => (
                                            <MenuItem key={elem.idMateria} value={elem.idMateria}> {elem.descripcion} </MenuItem>
                                        ))
                                    }
                                </Select>
                            </FormControl>
                        </Grid>

                    </Grid>

                </DialogContent>

                <DialogActions sx={ DialogActionsStyle }>
                    <Button disabled={loading} onClick={() => { setOpenModal(false); }}> Cancelar </Button>
                    <Button loading={loading} disabled={ tipoJuicio === 0 || materia === 0} onClick={handleGuardar} variant='contained'> Guardar </Button>
                </DialogActions>

            </Dialog>

        </Layout>

    )
}